var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.curHeader,{tag:"component"}),_c('div',{staticClass:"wrapper",style:({ backgroundImage: _vm.isbig == '' ? 'url('+_vm.bgImage+')' : ''})},[_c('router-view')],1),(_vm.isFooter)?_c('page-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }